import { render, staticRenderFns } from "./TextSeparator.vue?vue&type=template&id=6c103bc8&scoped=true&"
import script from "./TextSeparator.vue?vue&type=script&lang=js&"
export * from "./TextSeparator.vue?vue&type=script&lang=js&"
import style0 from "./TextSeparator.vue?vue&type=style&index=0&id=6c103bc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c103bc8",
  null
  
)

export default component.exports